import { createApp } from 'vue'
import { TelegramProvider } from 'vue-tg'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { apiService } from './services/api.js'
import './styles/tokens.css'
import './styles/pages.css'

// Применяем тему из localStorage ДО монтирования приложения
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  const THEME_STORAGE_KEY = 'app_theme'
  try {
    const savedTheme = localStorage.getItem(THEME_STORAGE_KEY)
    if (savedTheme && ['dark', 'light'].includes(savedTheme)) {
      const root = document.documentElement
      if (savedTheme === 'light') {
        // Светлая тема
        root.style.setProperty('--color-bg-primary', '#ffffff')
        root.style.setProperty('--color-bg-secondary', '#f5f5f5')
        root.style.setProperty('--color-bg-card', '#f5f5f5')
        root.style.setProperty('--color-text-primary', '#1a1a1a')
        root.style.setProperty('--color-text-secondary', '#666666')
        root.style.setProperty('--color-border', '#e0e0e0')
        root.style.setProperty('--color-icon', '#000000')
        root.style.setProperty('--color-icon-active', '#000000')
      } else {
        // Темная тема
        root.style.setProperty('--color-bg-primary', 'rgb(7, 39, 36)')
        root.style.setProperty('--color-bg-secondary', 'rgb(5, 26, 23)')
        root.style.setProperty('--color-bg-card', 'rgb(5, 26, 23)')
        root.style.setProperty('--color-text-primary', '#ffffff')
        root.style.setProperty('--color-text-secondary', '#a0a0a0')
        root.style.setProperty('--color-border', '#2a2a2a')
        root.style.setProperty('--color-icon', '#ffffff')
        root.style.setProperty('--color-icon-active', '#ffffff')
      }
    }
  } catch (error) {
    console.error('Error applying theme on init:', error)
  }
}

const app = createApp(App)

// Репорт клиентских ошибок в группу админов (через бэк /client-error) — чтобы видеть,
// когда у клиента что-то не подгрузилось (коингеко/сеть/рендер) и «клиент сидит с 0».
if (typeof window !== 'undefined') {
  window.addEventListener('error', (e) => {
    try { apiService.reportClientError('window.onerror', e?.error || e?.message) } catch (_) { /* noop */ }
  })
  window.addEventListener('unhandledrejection', (e) => {
    try { apiService.reportClientError('unhandledrejection', e?.reason) } catch (_) { /* noop */ }
  })
}
app.config.errorHandler = (err, instance, info) => {
  console.error('[Vue error]', err, info)
  try { apiService.reportClientError('vue:' + String(info || ''), err) } catch (_) { /* noop */ }
}

// Инициализация Telegram WebApp
if (typeof window !== 'undefined' && window.Telegram?.WebApp) {
  const tg = window.Telegram.WebApp
  tg.ready()
  tg.expand()
}

app.use(TelegramProvider).use(router).use(i18n).mount('#app')
